var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNeutralicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_531",
    "data-name": "Grupo 531",
    transform: "translate(0.173 0.362)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1514",
    "data-name": "Ret\\xE2ngulo 1514",
    width: 70,
    height: 70,
    rx: 10,
    transform: "translate(-0.173 -0.362)",
    fill: "#fed940"
  }), /*#__PURE__*/React.createElement("g", {
    id: "neutral",
    transform: "translate(14.897 14.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_482",
    "data-name": "Grupo 482",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_478",
    "data-name": "Grupo 478",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_477",
    "data-name": "Grupo 477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2071_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2072_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2073_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2074_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2075_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2076_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2077_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2078_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2079_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2080_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2081_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2082_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2083_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2084_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2085_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_163",
    "data-name": "Elipse 163",
    cx: 19.537,
    cy: 19.537,
    rx: 19.537,
    ry: 19.537,
    fill: "#fff"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_483",
    "data-name": "Grupo 483",
    transform: "translate(9.674 8.717)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_164",
    "data-name": "Elipse 164",
    cx: 3.11,
    cy: 3.11,
    rx: 3.11,
    ry: 3.11,
    fill: "#fed940"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_165",
    "data-name": "Elipse 165",
    cx: 3.11,
    cy: 3.11,
    rx: 3.11,
    ry: 3.11,
    transform: "translate(13.506)",
    fill: "#fed940"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_484",
    "data-name": "Grupo 484",
    transform: "translate(8.25 21.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_620",
    "data-name": "Caminho 620",
    d: "M152.055,274.167h22.574v3.8H152.055Z",
    transform: "translate(-152.055 -274.167)",
    fill: "#fed940"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralicon);
export default __webpack_public_path__ + "static/media/neutralicon.c8349b1e6ba6a38c57c601d6b9aa52f8.svg";
export { ForwardRef as ReactComponent };